// import Vue from 'vue'
// import Http from '@/utils/http'
import async from './network';
import cmdPage from './cmd';
import util from '../utils/util';

let cgiUrl = util.getCgiHost();
console.log('cgiUrl',cgiUrl)

export default {
    //获取注册验证码
    getRegisterCode(phone,captchaCode) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/register/getVerificationCode'
        params.parameters = {
            phone: phone,
            captchaCode:captchaCode
        }
        return async(cgiUrl, params, 'post')
    },
    //获取重置手机验证码
    getResetPwdCode(phone) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/resetPwd/getVerificationCode'
        params.parameters = {
            phone: phone
        }
        return async(cgiUrl, params, 'post')
    },
    //重置手机密码
    resetPwd(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/resetPwd'
        params.parameters = {
            phone: data.phone,
            pwd: data.pwd,
            verifyCode: data.verifyCode
        }
        return async(cgiUrl, params, 'post')
    },
    //获取绑定验证码
    getBindCode(phone,captchaCode) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/bind/getVerificationCode'
        params.parameters = {
            phone: phone
        }

        if (captchaCode != '') {
            params.parameters['captchaCode'] = captchaCode
        }
        return async(cgiUrl, params, 'post')
    },
    //获取绑定验证码
    bindUserPhone(phone, pwd, verifyCode) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/bindPhone'
        params.parameters = {
            phone: phone,
            pwd: pwd,
            verifyCode: verifyCode
        }
        return async(cgiUrl, params, 'post')
    },
    //注册
    register(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/register'
        params.parameters = {
            phone: data.phone,
            password: data.password,
            name:data.name,
            verifyCode: data.verifyCode
        }
        return async(cgiUrl, params, 'post')
    },
    //登录
    login(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/login'
        params.parameters = {
            phone: data.phone,
            pwd: data.pwd,
            verifyCode: data.verifyCode
        }
        return async(cgiUrl, params, 'post')
    },
    // 纪念馆首页
    getMemorialIndex(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/index'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    //纪念馆列表
    getMemorialList(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/list'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    //纪念馆详情
    getMemorialDetail(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/detail'
        params.parameters = {
            memorialId:data.memorialId,
        }
        return async(cgiUrl, params, 'post')
    },
    //祭文悼词分页
    getGrieveList(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/jisao/list'
        params.parameters = {
            page:data.page,
            pageSize:data.pageSize,
            jisaoType:data.jisaoType,
            memorialId:data.memorialId
        }
        return async(cgiUrl, params, 'post')
    },
    //获取祭扫物品
    getMemorialArticleList(type){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/article/options'
        params.parameters = {
            type:type
        }
        return async(cgiUrl, params, 'post')
    },
    //获取祭扫关系
    getRelations(){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/jisao/relations'
        return async(cgiUrl, params, 'post')
    },
    //祭扫保存
    addMemorial(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/jisao/add'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    //祭扫删除
    removeMemorial(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/jisao/delete'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    //获取个人信息
    getProfileInfo(){
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/profile'
        return async(cgiUrl, params, 'post')
    },
    //修改个人信息
    updateUserInfo(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/profile/update'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    //修改密码
    updatePwd(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'user/changePwd'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    //获取逝者性别
    getSexs(){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/sexs'
        return async(cgiUrl, params, 'post')
    },
    //获取相册列表
    getAlbumList(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/album/list'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    //纪念馆创建
    createdMemorial(data){
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/create'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    // 新闻动态分类动态数据
    newsCategory() {
        var params = cmdPage.getParameterDic()
        params.cmd = 'news/category/list'
        return async(cgiUrl, params, 'post')
    },
    // 上传文件
    uploadImgBase64(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'base/uploadImage/base64'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    // 祭扫记录删除
    memorailListDelete(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'memorial/jisao/delete'
        params.parameters = data;
        return async(cgiUrl, params, 'post')
    },
    // 首页新闻数据
    newsIndex(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'news/index'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 新闻分页数据
    newsList(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'news/list'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 新闻详情
    newsDetail(newsId) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'news/detail'
        params.parameters = {
            newsId: newsId
        }
        return async(cgiUrl, params, 'post')
    },
    // 地区数据
    getAreaData(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'base/area'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 发送验证码
    sendCode(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'business/reg/getVerificationCode'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 海葬预约参加年份选项
    getYear(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'activity/plan/year'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 海葬预约参加月份选项
    getMonth(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'activity/plan/month'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 预约基本数据（性别、证件类型、骨灰寄存处、参加地点）
    getCommonData(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'business/reg/commonData'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 预约列表
    orderList(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'business/list'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 预约保存
    saveBusiness(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'business/reg'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    //取消预约
    businessCancel(businessId) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'business/cancel'
        params.parameters = {
            businessId:businessId,
        }
        return async(cgiUrl, params, 'post')
    },
    // 预约信息
    businessInfo(businessId) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'business/info'
        params.parameters = businessId
        return async(cgiUrl, params, 'post')
    },
    // 栏目动态数据
    columnLists(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'column/list'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    },
    // 栏目内容
    columnDetail(columnId) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'column/detail'
        params.parameters = {
            columnId: columnId
        }
        return async(cgiUrl, params, 'post')
    },
    // 联系我们
    feedbackAdd(data) {
        var params = cmdPage.getParameterDic()
        params.cmd = 'feedback/add'
        params.parameters = data
        return async(cgiUrl, params, 'post')
    }
}
